export default {
  setVerbiage:(state, verbiage) => state.verbiage = verbiage,
  setLocale:(state, locale) => state.locale = locale
}